import { render, staticRenderFns } from "./UserOnfido.vue?vue&type=template&id=2bcdd066&"
import script from "./UserOnfido.vue?vue&type=script&lang=js&"
export * from "./UserOnfido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports